




























import {
  BButton, BModal, BForm, BFormInput, BFormGroup, BCard, BAlert, BLink, BCardText, BRow, BCol, BSpinner, BFormFile
} from 'bootstrap-vue'
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
 import PreferencesUtilisateurToolTip from './preferences/_ToolTip.vue'
import store from '@/store/index'
import { TypePreference } from '@/api/models/enums/typePreference';
import PreferencesUtilisateurAdherentsColumns from './preferences/_AdherentsColumns.vue';
@Component({
  components: {
    BCard,
    BAlert,
    BLink,
    BRow,
    BCol,
    BCardText,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    PreferencesUtilisateurToolTip,
    PreferencesUtilisateurAdherentsColumns,
    BFormFile
  }
})
export default class PreferencesUtilisateur extends Vue {
  userPreferences: [] = [];

  async created() {
    this.loadUserPreferences();

  }
  
  async loadUserPreferences() {
    this.userPreferences = store.getters['user/user_preferences'];

      if (!this.userPreferences.length) {
        this.$store.dispatch('user/saveUserPreference', {
          key : "DisplayToolTip",
          stockable : true,
          value : "true",
          type : TypePreference.ToolTip          
        });
    }
  }

  onMoveInactif(operations: any) {
    this.onMove(operations, false);
  }

  onMoveActif(operations: any) {
    this.onMove(operations, true);
  }

  onMove(operations: any, active: boolean) {
    if (operations.hasOwnProperty("moved")) {
      // let el = this
      //   .listTypes
      //   .items
      //   .find(x => x.id == operations.moved.element.id)

      //   if(el) {
      //     el.ordre = operations.moved.newIndex + 1;
      //     this.selectedTypeContrats = el;
      //     this.confirmUpdate();
      //   } 
    }
    //added
    if (operations.hasOwnProperty("added")) {
      // let el = this
      //   .listTypes
      //   .items
      //   .find(x => x.id == operations.added.element.id);

      // if (el) {
      //   el.actif = active;
      //   el.ordre = operations.added.newIndex + 1;
      //   this.selectedTypeContrats = el;
      //   this.confirmUpdate();
      // } 
    }
  }
}
